import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';

import withToolsetPlaceholder from 'components/ToolsetPlaceholder';

import GraphicalStatisticsComponent from './Component';

import { getFilteredParametersValuesNotEmptyLength, getFrequencyParameterType, isFrequencyOrContingencyTable } from 'store/dataset';

import {
  setPrimaryParameterName,
  setSecondaryParameterName
} from 'store/scenes/graphicalStatistics/settingsPane/actions';

import {
  getActiveChartsAndGraphsTab
} from 'store/scenes/graphicalStatistics/rightPane/selectors';
import { setBinWidthForParameter } from 'store/scenes/graphicalStatistics/rightPane/actions';

import {
  getPrimaryParameterName,
  getSecondaryParameterName,

  getPrimaryParameterType,
  getSecondaryParameterType
} from 'store/scenes/graphicalStatistics/settingsPane/selectors';

import { getFrequencyDataSetLength } from '../../store/dataset';

const GraphicalStatisticsContainer = props => {
  const {
    firstParameterName = null,
    secondParameterName = null,

    firstParameterType = null,
    secondParameterType = null,

    activeChartsAndGraphsTab
  } = props;

  const firstParameterSelected = !!firstParameterName;
  const showRightAndBottomPanes = props.datasetLength > 0;

  const frequencyDataSetLength = useSelector(state => getFrequencyDataSetLength(state));
  const isContingencyDataSetType = frequencyDataSetLength === 2;
  const isFrequencyDataSetType = frequencyDataSetLength === 1;

  const isFrequencyTable = isContingencyDataSetType || isFrequencyDataSetType;
  const getFirstParameterType = isContingencyDataSetType
    ? props.frequencyParametersType(firstParameterName)
    : firstParameterType;

  const getSecondParameterType = isContingencyDataSetType
    ? props.frequencyParametersType(secondParameterName)
    : secondParameterType;

  const isFirstParamNumerical = getFirstParameterType === 'numerical';
  const isFirstParamCategorical = getFirstParameterType === 'categorical';
  const isSecondParamNumerical = getSecondParameterType === 'numerical';
  const isSecondParamCategorical = getSecondParameterType === 'categorical';

  const isHistogram = props.isHistogramChosen &&
    !secondParameterName &&
    (isFirstParamNumerical ||
      ((isFirstParamNumerical && isSecondParamCategorical) ||
      (isFirstParamCategorical && isSecondParamNumerical)));

  const isGroupHistogram = props.isHistogramChosen &&
    secondParameterName &&
    ((isFirstParamNumerical && isSecondParamCategorical) ||
          (isFirstParamCategorical && isSecondParamNumerical));

  // for frequency table: show BottomPane only for Bar Chart and PieChart
  const showOnlyForBarChartAndPieChart = activeChartsAndGraphsTab === 4 || activeChartsAndGraphsTab === 5;
  const showBottomPane = isFrequencyTable
    ? showRightAndBottomPanes && firstParameterSelected && showOnlyForBarChartAndPieChart
    : showRightAndBottomPanes && firstParameterSelected;

  const handleFirstParameterNameChange = name => {
    if (activeChartsAndGraphsTab === 0) {
      props.setBinWidthForParameter(name);
    }
    props.handleFirstParameterNameChange(name);
  };

  const handleSecondParameterNameChange = name => {
    if (!isFrequencyTable) {
      if (isFirstParamNumerical || !name) {
        if (activeChartsAndGraphsTab === 0) {
          props.setBinWidthForParameter(props.firstParameterName);
        }
      } else {
        props.setBinWidthForParameter(name);
      }
    }
    props.handleSecondParameterNameChange(name);
  };

  const numericalParameterName = () => {
    if (isFirstParamNumerical) {
      return firstParameterName;
    }

    if (isSecondParamNumerical) {
      return secondParameterName;
    }

    return '';
  };

  const categoricalParameterName = () => {
    if (isFirstParamCategorical) {
      return firstParameterName;
    }

    if (isSecondParamCategorical) {
      return secondParameterName;
    }

    return '';
  };

  return (
    <GraphicalStatisticsComponent
      firstParameterName={firstParameterName}
      secondParameterName={secondParameterName}
      firstParameterSelected={firstParameterSelected}
      showRightAndBottomPanes={showRightAndBottomPanes}
      onFirstParameterNameChange={handleFirstParameterNameChange}
      onSecondParameterNameChange={handleSecondParameterNameChange}
      showHistogramFields={
        !!isHistogram || !!isGroupHistogram
      }
      isFrequencyTable={isFrequencyTable}
      isFirstParamNumerical={isFirstParamNumerical}
      isFirstParamCategorical={isFirstParamCategorical}
      isSecondParamNumerical={isSecondParamNumerical}
      isSecondParamCategorical={isSecondParamCategorical}

      firstParameterType={getFirstParameterType}
      secondParameterType={getSecondParameterType}
      numericalName={numericalParameterName()}
      categoricalName={categoricalParameterName()}
      showBottomPane={showBottomPane}
    />
  );
};

const mapStateToProps = state => {
  const firstParameterName = getPrimaryParameterName(state);
  const secondParameterName = getSecondaryParameterName(state);

  return {
    datasetLength: getFilteredParametersValuesNotEmptyLength(
      state,
      firstParameterName,
      secondParameterName
    ),

    firstParameterName,
    secondParameterName,
    frequencyParametersType: getFrequencyParameterType(state),

    isHistogramChosen: getActiveChartsAndGraphsTab(state) === 0,
    firstParameterType: getPrimaryParameterType(state),
    secondParameterType: getSecondaryParameterType(state),
    isFrequencyTable: isFrequencyOrContingencyTable(state),
    activeChartsAndGraphsTab: getActiveChartsAndGraphsTab(state)
  };
};

GraphicalStatisticsContainer.propTypes = {
  firstParameterName: PropTypes.string,
  secondParameterName: PropTypes.string,

  firstParameterType: PropTypes.string,
  secondParameterType: PropTypes.string,

  handleFirstParameterNameChange: PropTypes.func.isRequired,
  handleSecondParameterNameChange: PropTypes.func.isRequired,

  datasetLength: PropTypes.number.isRequired,
  setBinWidthForParameter: PropTypes.func.isRequired,
  isHistogramChosen: PropTypes.bool.isRequired,
  activeChartsAndGraphsTab: PropTypes.number,
  frequencyParametersType: PropTypes.func
};

const mapDispatchToProps = {
  handleFirstParameterNameChange: setPrimaryParameterName,
  handleSecondParameterNameChange: setSecondaryParameterName,
  setBinWidthForParameter
};

export default withToolsetPlaceholder(
  connect(mapStateToProps, mapDispatchToProps)(
    GraphicalStatisticsContainer
  )
);
